import './Header.css';
import React, { useContext } from 'react';
import { AuthContext } from '../../services/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import logo2 from '../../assets/GoesGreen-300x74.png';


function Header() {
  const { user, logout, loginWithMicrosoft, loginWithGoogle } = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <header>
      <Link to="/">
        <img src={logo2} alt="GoesGreen Logo" className="static-logo2" />
      </Link>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <p style={{ margin: 0 }}>
          {user ? (
            <>
              Bienvenido, {user.displayName || user.name || user.email}.{" "}
              <button onClick={logout}>Cerrar Sesión</button>
            </>
          ) : (
            <>
              <button onClick={loginWithMicrosoft}>
                Iniciar Sesión con Microsoft
              </button>

              <button onClick={loginWithGoogle} style={{ marginLeft: "0.5rem" }}>
                Iniciar Sesión con Google
              </button>
            </>
          )}
        </p>
        {user && (
          <button style={{ marginTop: '0.5rem' }} onClick={() => navigate('/cauchari_cna')}>Inicio de CNA</button>
        )}
      </div>
    </header>
  );
}

export default Header;
